export default __webpack_public_path__ + "0b837ccb90b893d1a8544be87b45e2eb.svg";